module.exports = __webpack_public_path__ + "static/media/profile.15dc07ae.png";